<template>
  <b-row>
    <b-col cols="12">
      <clinic-dentist-card />
      <clinic-dentists></clinic-dentists>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ClinicDentistCard from './ClinicDentistCard.vue'
import ClinicDentists from '@/views/admin/clinic-dentists/ClinicDentists.vue'

export default {
  components: {
    ClinicDentists,
    BRow,
    BCol,

    ClinicDentistCard,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
